<template>
  <div>
    <div id="buttons" className="ui grey three item inverted bottom fixed menu transition hidden">
    </div>
     <iframe v-if="data" :src="data" id="viewer" class="w-100" :height="height" scrolling="no" @load="load"></iframe>
    <p v-else>Loading PDF...</p>
  </div>
</template>

<script>
export default {
  data() {
    return {
      data: null,
      height: window.screen.height + "px",
      filter: {},
      timeoutId: null,
      timeoutDuration: 10000
    }
  },
  mounted() {
    this.show(process.env['VUE_APP_TAC_ID_' + this.$i18n.locale.toUpperCase()])
  },
  methods: {
    async show() {
      // When debugging the PDF viewer on local, use this instead because Google Document viewer can not load local IP address.
      // The message "No preview availale" will show up if you do not use this code.
      this.data = "https://docs.google.com/gview?embedded=true&url=" + "https://stg-app.checkinherenow.com" +  "/terms/terms_" + this.$i18n.locale + ".pdf"
      // this.data = "https://docs.google.com/gview?embedded=true&url=" + window.location.origin +  "/terms/terms_" + this.$i18n.locale + ".pdf"
      this.startTimeout();
    },
    startTimeout() {
      this.timeoutId = setTimeout(() => {
        console.log('Refreshing iframe due to timeout');
        const currentData = this.data;
        this.data = null;
        this.$nextTick(() => {
          this.data = currentData;
        });
      }, this.timeoutDuration);
    },
    onLoad() {
      if (this.timeoutId) {
        clearTimeout(this.timeoutId);
        this.timeoutId = null;
      }
      console.log("loaded");
    },
    load() {
      if(document.querySelector('#viewer')) {
        console.log("loaded")
        clearTimeout(this.timeoutId);
        this.timeoutId = null; // Reset timeoutId
      } else {
        console.log("not loaded")
      }
    }
  }
}
</script>
<style lang="scss">
/*
* NOTE: Please don't pollute global css scope from inside a non root component
*/

// html {

//   .modal-body {
//     padding: 5% 5%;
//     .remove-all-styles {
//       all: initial;
//       text-align: justify;

//       p {
//         margin-bottom: 0.5rem;
//       }
//     }


//     #header {
//       background-color: initial !important;
//     }

//     ol {
//       list-style-type: decimal !important;
//       padding-left: 1rem;

//       li {
//         font: initial !important;
//         margin-bottom: 8px !important;
//         color: #0d0d0d !important;

//         h4 {
//           margin-top: 20px;
//         }

//         p {
//           padding-left: 0px !important;
//           padding-top: 5px !important;
//         }

//         span {
//           position: relative !important;
//         }
//       }
//     }
//   }

// }
</style>
